<template>
  <div class="horario-lista-agrupada">
    <v-alert
      v-if="deveExibirMensagemVazia"
      dense
      outlined
      type="info"
      class="horario-lista-agrupada__empty"
    >
      Nenhum registro encontrado.
    </v-alert>

    <section v-for="grupo in grupos" :key="grupo.data" class="horario-lista-agrupada__grupo">
      <div class="font-weight-bold horario-lista-agrupada__titulo">
        {{ grupo.titulo ?? "- - -" }}
      </div>
      <horario-batida-card v-for="item in grupo.items" :key="item.id" :item="item" />
    </section>
  </div>
</template>

<script>
import HorarioBatidaCard from "./HorarioBatidaCard.vue";

export default {
  name: "HorarioListaAgrupada",
  components: {
    HorarioBatidaCard,
  },
  props: {
    registros: {
      type: [Object, Array, null],
      default: null,
    },
    consultaIniciada: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    possuiConsultaIniciada() {
      if (this.consultaIniciada !== undefined) {
        return this.consultaIniciada;
      }

      return this.registros !== null && this.registros !== undefined;
    },
    grupos() {
      if (!this.possuiConsultaIniciada) {
        return [];
      }

      if (Array.isArray(this.registros)) {
        return [
          {
            data: "dia",
            titulo: "Registros do dia",
            items: this.registros,
          },
        ].filter((grupo) => grupo.items.length);
      }

      return Object.keys(this.registros || {}).map((data) => {
        const items = this.registros[data] || [];
        const primeiroItem = items[0] || {};
        return {
          data,
          titulo: primeiroItem.data_formatada || data,
          items,
        };
      });
    },
    temRegistros() {
      return this.grupos.some((grupo) => grupo.items.length);
    },
    deveExibirMensagemVazia() {
      return this.possuiConsultaIniciada && !this.temRegistros;
    },
  },
};
</script>
<style scoped>
.horario-lista-agrupada__empty {
  margin-top: 0;
}

.horario-lista-agrupada__grupo + .horario-lista-agrupada__grupo {
  margin-top: 24px;
}

.horario-lista-agrupada__titulo {
  font-size: 1.1rem;
  margin-bottom: 12px;
}
</style>
